import { useEffect, useState } from '../../common/common';
import { useErrorContext } from '../../context/ErrorContext';
import axiosJWT from '../../secureAPI/axiosJWT';
import useGetUserData from '../../secureAPI/GetUserData';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { showToast } from '../../Utils/toastUtils';
import { validateAddUserForm } from '../../validation/Authentication/Validation';

const MidAddUsers = () => {
    const { users, userPlan, Remainuser, subUser } = useGetUserData();
    const [isLoading, setisLoading] = useState(false);
    const { setValidationError, clearAllErrors } = useErrorContext();
    
    const [userTypes, setUserTypes] = useState([]);
    const [countryData, setCountryData] = useState([]);
    const [stateData, setStateData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [error, setError] = useState(null);
    const [values, setvalues] = useState(
        {
            userType: '',
            fullName: '',
            primaryNumber: '',
            secondaryNumber: '',
            emailAddress: '',
            address: '',
            pincode: '',
            area: '',
            workpincode: '',
            passWord: '',
            confirmpassword: '',
            CountryId: null,
            StateId: null,
            CityId: null,
            WorkCountryId: null,
            WorkStateId: null,
            WorkCityId: null,
        }
    );

    const validateAndSetErrors = (values) => {
        const validationErrors = validateAddUserForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "primaryNumber" || name === "secondaryNumber") {
            if (value.length < 11) {
                setvalues({ ...values, [name]: value })
            }
        }
        setvalues({ ...values, [name]: value })
        // const validationErrors = validateAndSetErrors(values);

    }
    useEffect(() => {
        getCountries();
        getSubUsertype();
    }, [users]);
    // useEffect(() => {
    //     showToast('', '');

    //     fetchUserPlanOrderData();
    // }, []);

    // const fetchUserPlanOrderData = async () => {

    //     try {
    //         StartLoading(setisLoading, setisDisabled);
    //         const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetUserPlansOrderDetails`, {}, { withCredentials: true });
    //         if (response.data?.success && response.data.data?.length > 0) {
    //             const plan = response.data.data[0];

    //             setplanOrderDetails();
    //         }
    //     } catch (err) {
    //         // console.error("Failed to load new orders, please try again later ", err);
    //     } finally {
    //         StopLoading(setisLoading, setisDisabled)
    //     }


    // };
    const handlesetusertype = (usertype) => {
        setvalues(prev => ({ ...prev, userType: usertype }));
    };

    const handleGetState = (country) => {
        setvalues(prev => ({ ...prev, CountryId: country }));
        getStates(country.value);
    };
    const handleGetCities = (state) => {
        setvalues(prev => ({ ...prev, StateId: state }));
        getCities(state.value);
    };
    const handleSetCityId = (city) => {
        setvalues(prev => ({ ...prev, CityId: city }));
    };
    const handleGetWorkState = (country) => {
        setvalues(prev => ({ ...prev, WorkCountryId: country }));
        getStates(country.value);
    };

    const handleGetWorkCities = (state) => {
        setvalues(prev => ({ ...prev, WorkStateId: state }));
        getCities(state.value);
    };

    const handleSetWorkCityId = (city) => {
        setvalues(prev => ({ ...prev, WorkCityId: city }));
    };


    const getCountries = async () => {
        StartLoading(setisLoading);
        try {
            const res = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getcountries`);
            StopLoading(setisLoading);

            if (res.data.success === 1) {
                const transformedData = res.data.data.map(country => ({
                    label: country.name,
                    value: country.id,
                }));
                setCountryData(transformedData);
            } else {
                showToast(res.data.message, 'error');
            }
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find countries, please try again later", 'error');
        }
    };

    const getStates = async (countryId) => {
        StartLoading(setisLoading);
        try {
            const res = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getstates`, {
                countryid: countryId
            });
            StopLoading(setisLoading);

            if (res.data.success === 1) {
                const transformedData = res.data.data.map(state => ({
                    label: state.name,
                    value: state.id,
                }));
                setStateData(transformedData);
            } else {
                showToast(res.data.message, 'error');
            }
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find states, please try again later", 'error');
        }
    };

    const getCities = async (stateId) => {
        StartLoading(setisLoading);
        try {
            const res = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getcities`, {
                stateid: stateId
            });
            StopLoading(setisLoading);

            if (res.data.success === 1) {
                const transformedData = res.data.data.map(city => ({
                    label: city.name,
                    value: city.id,
                }));
                setCityData(transformedData);
            } else {
                showToast(res.data.message, 'error');
            }
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find cities, please try again later", 'error');
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validateAndSetErrors(values);
        // console.log({ validationErrors: validationErrors })
        if (Object.keys(validationErrors).length === 0) {
            clearAllErrors();
            AddUser();
        }
    };

    const AddUser = async () => {
        // console.log({ values: values });
        StartLoading(setisLoading);
        try {
            const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Adduser`, { values, app: 0 }, { withCredentials: true });

            StopLoading(setisLoading);

            if (response.data.success === 1) {
                showToast(response.data.message, 'success');

                setvalues({
                    userType: '',
                    fullName: '',
                    primaryNumber: '',
                    secondaryNumber: '',
                    emailAddress: '',
                    address: '',
                    pincode: '',
                    area: '',
                    workpincode: '',
                    passWord: '',
                    confirmpassword: '',
                    CountryId: null,
                    StateId: null,
                    CityId: null,
                    WorkCountryId: null,
                    WorkStateId: null,
                    WorkCityId: null,
                })
                // console.log(response.data.data);
                // Reset or update state as needed
            } else {
                showToast(response.data.message, 'error');
                setvalues({
                    userType: '',
                    fullName: '',
                    primaryNumber: '',
                    secondaryNumber: '',
                    emailAddress: '',
                    address: '',
                    pincode: '',
                    area: '',
                    workpincode: '',
                    passWord: '',
                    confirmpassword: '',
                    CountryId: null,
                    StateId: null,
                    CityId: null,
                    WorkCountryId: null,
                    WorkStateId: null,
                    WorkCityId: null,
                })
            }
        } catch (err) {
            StopLoading(setisLoading);
            if (err.response?.status === 401) {
                // Handle unauthorized
            } else {
                showToast(err.response?.data?.message || "Failed to add Price List, please try again later", 'error');
            }
        }
    };
    const getSubUsertype = async () => {
        StartLoading(setisLoading);
        setError(null);

        try {
            const res = await axiosJWT.post(
                `${process.env.REACT_APP_API_URL}/api/GetSubusertypes`,
                {},
                { withCredentials: true }
            );

            const options = res.data.data?.map(type => ({
                value: type.id,
                label: type.user_type_name
            })) || [];

            setUserTypes(options);
        } catch (err) {
            console.error('Error fetching user types:', err);
            setError('Failed to load user types');
        } finally {
            StopLoading(setisLoading);
        }
    };


    return { users, userPlan, Remainuser, subUser, userPlan, Remainuser, subUser, isLoading, userTypes, handleSubmit, values, countryData, stateData, cityData, handleGetState, handleGetCities, handleSetCityId, error, handlesetusertype, handleChange, handleGetWorkState, handleGetWorkCities, handleSetWorkCityId };
};

export default MidAddUsers;